<template>
<form @submit.stop.prevent="register()" class="stripe-component">
  <div class="sr-form-row">
    <div  ref="cardErrors" class="sr-field-error text-danger small" id="card-errors" role="alert"></div>
    <div class="sr-input sr-element sr-card-element stripe-element" id="card-element">
        <div ref="card"></div>
    </div>
  </div>
  <button class="btn btn-primary" type="submit" >{{$t('subscription.subscribe')}} <div v-show="loading"> <i class="fa-light fa-circle-notch fa-spin"></i> </div> </button>
</form>
</template>
<script>
import Store from '@/store/store.js'
let stripe = Stripe(Store.getters.stripePublicKey);
let elements = stripe.elements();
let card = null
export default {
  props:{
    billingInfo: Object,
    paymentError: Boolean
  },
  data () {
    return {
      clientSecret: null,
      loading: false
    }
  },
  methods: {
    register(){
      this.loading = true
      const displayError = document.getElementById("card-errors");
      displayError.textContent = ''

      stripe.confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: card,
          billing_details: { name: this.billingInfo.contact_name }
        }
      }).then(result => {
          this.loading = false
          if(result.error){
              displayError.textContent = result.error.message
          } else{
            const cardId = result.setupIntent.payment_method
            this.$emit('generated-token', cardId)
          }
      }).catch(e => {
        this.loading = false
        displayError.textContent = this.$t('subscription.payment-error')
      })
    }
  },
  mounted() {
      card = elements.create('card');
      card.mount(this.$refs.card);

      this.$store.dispatch("getSetupintent").then(res => {
        this.clientSecret = res.client_secret
      })
  },
  beforeDestroy() {
    card.destroy(this.$refs.card);
  },
  watch: {
    paymentError:{
      handler: function(){
        if(this.paymentError == true){
          const displayError = document.getElementById("card-errors");
          displayError.textContent = this.$t('subscription.payment-error')
        }
      }
    }
  }
};
</script>
<style lang="less">
.stripe-component{
  position: relative;
  #card-errors{
    width: 300px;
  }

  button{
    display: flex;
    gap: 4px;
    align-items: center;
  }
}

.stripe-element {
  width: 300px;
  margin-bottom: 12px;
  border: none;
  border-bottom: 1px solid #ccc;  
  padding: 10px 0;
  cursor: text;
  color: #495057;
  font-weight: 500;
  background-color: inherit;
}

.stripe-element:focus-within {
  outline: 0;
  border: none;                           
  border-bottom: 1px solid #666;         
  border-color: #495057;
  color: #495057;
}
.stripe-element.complete {
  border-bottom: 1px solid #28a745;
}
</style>

